module.exports = __webpack_public_path__ + "static/media/logo_puc.86e373b6.png";